export function mainblock() {
	var popularSlider = new Swiper(".popular-cards", {
		slidesPerView: 1,
		spaceBetween: 0,
                autoplay: false,
		loop: true,
		navigation: {
			nextEl: ".popular-cards .arrow_next",
			prevEl: ".popular-cards .arrow_prev",
		},
		pagination: {
			el: '.popular-cards .swiper-pagination',
			type: 'custom',
			renderCustom: function (swiper, current, total) {
				return '<div class="swiper-pagination__curr">' + current + '</div>'
					+ '<div class="swiper-pagination__text">' + ' / ' + '</div>' +
					'<div class="swiper-pagination__all">' + total + '</div>';
			}
		},
	});
}